import { NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';

import { FormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  RECAPTCHA_SETTINGS,
  RECAPTCHA_LANGUAGE,
  RecaptchaSettings,
  RecaptchaModule,
} from 'ng-recaptcha';

import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/zip';
import 'rxjs/add/operator/bufferCount';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import {
  MatChipsModule,
  MatIconModule,
  MatIconRegistry,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatInputModule,
  MatRadioModule,
  MatCheckboxModule,
  MatSelectModule,
  MatNativeDateModule, DateAdapter, NativeDateAdapter,
  MatDatepickerModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatTooltipModule,
  MatSnackBarModule,
  MatMenuModule,
  MatToolbarModule,
  MatSidenavModule,
  MatCardModule,
  MatTabsModule,
  MatExpansionModule,
  MatListModule,
  MatGridListModule,
  MatTableModule,
  MatPaginatorModule,
  MatSlideToggleModule,
  MatDialogModule,
} from '@angular/material';
import {
  CovalentDataTableModule,
  CovalentMediaModule,
  CovalentPagingModule,
  CovalentSearchModule,
  CovalentExpansionPanelModule,
  CovalentNotificationsModule,
  CovalentMenuModule,
  CovalentStepsModule,
  ITdDataTableColumn,
  IPageChangeEvent,
} from '@covalent/core';
import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import 'hammerjs';
import { MyDatePickerModule } from 'mydatepicker';
import {MomentModule} from 'angular2-moment/moment.module';
import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
// import { environment } from '../../environments/enviroment';

const agm = AgmCoreModule.forRoot({
  apiKey: 'AIzaSyBqxDhVkFSeBGKcmFahzp3ojblLZOorM6Q',
  libraries: ['drawing'],
  region: 'AR'
});

const recaptcha = RecaptchaModule.forRoot();

const modules = [
  agm.ngModule,
  AgmJsMarkerClustererModule,
  BrowserModule,
  BrowserAnimationsModule,
  FormsModule,
  MatChipsModule,
  MatIconModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatInputModule,
  MatRadioModule,
  MatCheckboxModule,
  MatSelectModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatTooltipModule,
  MatSnackBarModule,
  MatMenuModule,
  MatToolbarModule,
  MatSidenavModule,
  MatCardModule,
  MatTabsModule,
  MatExpansionModule,
  MatListModule,
  MatGridListModule,
  MatTableModule,
  MatPaginatorModule,
  MatSlideToggleModule,
  MatDialogModule,

  CovalentDataTableModule,
  CovalentMediaModule,
  CovalentPagingModule,
  CovalentSearchModule,
  CovalentExpansionPanelModule,
  CovalentNotificationsModule,
  CovalentMenuModule,
  CovalentStepsModule,

  NgxChartsModule,
  recaptcha.ngModule,
  RecaptchaFormsModule,
  MyDatePickerModule,
  MomentModule,
  PasswordStrengthBarModule,
];

@NgModule({
  imports: modules,
  exports: modules,
  providers: [
    ...agm.providers, recaptcha.providers
    ]
})

export class VendorModule {
  constructor(
    icons: MatIconRegistry,
    sanitizer: DomSanitizer,
    dateAdapter: DateAdapter<NativeDateAdapter>,
  ) {
    dateAdapter.setLocale('es' || navigator.language);
    icons.registerFontClassAlias('fontawesome', 'fa');
    function add(name, url) {
      icons.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(url));
    }
    add('cambiemos', 'assets/images/logo_color.png');

  }
}



// WEBPACK FOOTER //
// ./src/app/core/vendor.module.ts